import ko = require("knockout");
import Q = require("q");
import TFS_Host_TfsContext = require("Presentation/Scripts/TFS/TFS.Host.TfsContext");
import WIT_Contracts = require("TFS/WorkItemTracking/Contracts");
import WIT_WebApi = require("TFS/WorkItemTracking/RestClient");
import TCM_Contracts = require("TFS/TestManagement/Contracts");
import TCM_WebApi = require("TFS/TestManagement/RestClient");
import VSS_Common_Contracts = require("VSS/WebApi/Contracts");
import VSS_Service = require("VSS/Service");
import WITOM = require("WorkItemTracking/Scripts/TFS.WorkItemTracking");
import ViewModel = require("Agile/Scripts/Card/CardsAnnotationsTestAnnotationViewModels");

import Contracts = require("Agile/Scripts/Card/CardsAnnotationsTestAnnotationContracts");
import WebApi = require("Agile/Scripts/Card/CardsAnnotationsTestAnnotationWebApi");
import Telemetry = require("Agile/Scripts/Card/CardsAnnotationsTestAnnotationTelemetry");
import TFS_Knockout = require("Presentation/Scripts/TFS/TFS.Knockout");
import Utils_String = require("VSS/Utils/String");
import { WorkItemManager } from "WorkItemTracking/Scripts/OM/WorkItemManager";
import VSS = require("VSS/VSS");
import * as WITControls_LAZY_LOAD from "WorkItemTracking/Scripts/TFS.WorkItemTracking.Controls";
import TFS_OM_Common = require("Presentation/Scripts/TFS/TFS.OM.Common");
import WITConstants = require("Presentation/Scripts/TFS/Generated/TFS.WorkItemTracking.Constants");

TFS_Knockout.overrideDefaultBindings()

var parentTestedByLinkName = "Microsoft.VSTS.Common.TestedBy-Reverse";

export interface ITestSuiteModel {
    testSuiteId: number;
    testPlanId: number;
    testPoints: KnockoutObservableArray<ITestPointModel>;
    refresh: (teamId: string, requirementId: number) => IPromise<number>;
    updateTestCasesOrder: (testCasesOrder: TCM_Contracts.SuiteEntryUpdateModel[]) => IPromise<TCM_Contracts.SuiteEntryUpdateModel[]>;
}

export interface IWorkItemOption {
    save: () => void;
    close: (workItem?: WITOM.WorkItem) => void;
}

export class TestSuiteModel implements ITestSuiteModel {
    public testSuiteId = 0;
    public testPlanId = 0;
    public testPoints: KnockoutObservableArray<ITestPointModel> = ko.observableArray([]);

    constructor(suite?: Contracts.ITestSuite) {
        if (suite) {
            this._populate(suite);
        }
    }

    public refresh(teamId: string, requirementId: number): IPromise<number> {
        return WebApi.getClient().beginRefreshSuite(teamId, requirementId, this.testPlanId, this.testSuiteId)
            .then((suite: Contracts.ITestSuite) => {
                this._populate(suite);
                return this.testSuiteId;
            });
    }

    public updateTestCasesOrder(testCasesOrder: TCM_Contracts.SuiteEntryUpdateModel[]): IPromise<TCM_Contracts.SuiteEntryUpdateModel[]> {
        var tcmClient = VSS_Service.getClient<TCM_WebApi.TestHttpClient5>(TCM_WebApi.TestHttpClient5);
        var project = TFS_Host_TfsContext.TfsContext.getDefault().contextData.project.name;
        return tcmClient.reorderSuiteEntries(testCasesOrder, project, this.testSuiteId);
    }

    private _populate(suite: Contracts.ITestSuite) {
        this.testSuiteId = suite.testSuiteId;
        this.testPlanId = suite.testPlanId;
        var points: ITestPointModel[] = [];
        if (suite.testPoints) {
            $.each(suite.testPoints, (i, testPoint: Contracts.ITestPoint) => {
                points.push(new TestPointModel(testPoint));
            });
        }
        this.testPoints(points);
    }
}

export interface ITestPointModel {
    id: KnockoutObservable<number>;
    testCase: KnockoutObservable<ITestCaseModel>;
    outcome: KnockoutObservable<Contracts.TestOutcome>;
    //TODO: Move errorMessage and isErrorOccured in TestPointViewModel
    isErrorOccured: KnockoutComputed<boolean>;
    errorMessage: KnockoutObservable<string>;
    sequenceNumber: KnockoutObservable<number>;
    setOutcome: (teamId: string, suiteId: number, planId: number, outcome: Contracts.TestOutcome) => IPromise<void>;
}

export class TestPointModel implements ITestPointModel {
    private static MaxSequenceNumber: number = 99999999;

    public id: KnockoutObservable<number> = ko.observable(0);
    public testCase: KnockoutObservable<ITestCaseModel>;
    public isErrorOccured: KnockoutComputed<boolean>;
    public errorMessage: KnockoutObservable<string> = ko.observable("");
    public sequenceNumber: KnockoutObservable<number> = ko.observable(TestPointModel.MaxSequenceNumber);
    public outcome: KnockoutObservable<Contracts.TestOutcome> = ko.observable(Contracts.TestOutcome.Active);

    constructor(testPoint?: Contracts.ITestPoint) {
        this.testCase = ko.observable(new TestCaseModel());
        if (testPoint) {
            this._populate(testPoint);
        }
        this.isErrorOccured = ko.computed(() => {
            if (this.errorMessage()) {
                return this.errorMessage() !== "";
            }
            return false;
        });
    }

    public setOutcome(teamId: string, suiteId: number, planId: number, outcome: Contracts.TestOutcome): IPromise<any> {
        if (outcome === this.outcome()) {
            return Q(undefined);
        }

        this.outcome(outcome);

        Telemetry.TelemeteryHelper.publishFeatureTelemetry(Telemetry.FeatureScenarios.SetOutcome, { "Outcome": Contracts.TestOutcome[outcome] });

        return WebApi.getClient().beginSetOutcome(teamId, suiteId, planId, this.id(), outcome);
    }

    private _populate(testPoint: Contracts.ITestPoint) {
        this.id(testPoint.testPointId);
        var testCase: ITestCaseModel = new TestCaseModel(testPoint);
        this.testCase = ko.observable(testCase);
        this.sequenceNumber = ko.observable(testPoint.sequenceNumber);
        this.outcome = ko.observable(Contracts.TestOutcomeHelper.fromString(testPoint.outcome));
    }
}

export interface IRequirementModel {
    id: number,
    areaPath: string,
    iterationPath: string
}

export interface ITestCaseModel {
    id: number;
    name: KnockoutObservable<string>;
    beginCreate: (requirement: IRequirementModel, testCaseWorkItemType: string, testPointViewModel: ViewModel.TestPointViewModel) => IPromise<WIT_Contracts.WorkItem>;
    beginUpdate: () => IPromise<WIT_Contracts.WorkItem>;
    beginUpdateRequirementId: (newRequirementId: number, oldRequirementId: number, removeExistingLink: boolean) => IPromise<WIT_Contracts.WorkItem>;
    beginRemove: (requirementId: number) => IPromise<WIT_Contracts.WorkItem>;
}

export interface ITestCaseModelOptions {
    onDiscard: (testPointViewModel: ViewModel.TestPointViewModel) => IPromise<any>;
}

export class TestCaseModel implements ITestCaseModel {
    public id = 0;
    public name: KnockoutObservable<string> = ko.observable("");
    private _workItemSaved: boolean;
    private _onDiscard: (testPoint: any) => IPromise<any>;

    constructor(testPoint?: Contracts.ITestPoint, options?: ITestCaseModelOptions) {
        if (testPoint) {
            this.id = testPoint.testCaseId;
            this.name(testPoint.testCaseTitle);
        }

        if (options) {
            this._onDiscard = options.onDiscard;
        }
    }

    public beginCreate(requirement: IRequirementModel, testCaseWorkItemType: string, testPointViewModel?: ViewModel.TestPointViewModel): IPromise<WIT_Contracts.WorkItem> {
        var witClient = WIT_WebApi.getClient();
        var project = TFS_Host_TfsContext.TfsContext.getDefault().contextData.project.name;

        let options = {
            save: () => {
                this._workItemSaved = true;
            },
            close: (workItem: WITOM.WorkItem) => {
                if (this._workItemSaved) {
                    this._workItemSaved = false;
                    this.id = workItem.id;
                    this.name(workItem.getTitle());
                }
                else {
                    if (this._onDiscard) {
                        this._onDiscard(testPointViewModel);
                    }
                }
            }
        } as IWorkItemOption;

        return witClient.createWorkItem(TestCaseHelper.getCreatePatchDocument(this.name(), requirement), project, testCaseWorkItemType)
            .then((wit: WIT_Contracts.WorkItem) => {
                this.id = wit.id;
                return wit;
            }, () => {
                let witStore: WITOM.WorkItemStore;
                witStore = TFS_OM_Common.ProjectCollection.getDefaultConnection().getService<WITOM.WorkItemStore>(WITOM.WorkItemStore);
                witStore.beginGetProject(TFS_Host_TfsContext.TfsContext.getDefault().navigation.projectId, (project: WITOM.Project) => {
                    //Get Default work item under TestCase Category
                    project.beginGetWorkItemType(testCaseWorkItemType, (wit) => {
                        let workItem = WorkItemManager.get(witStore).createWorkItem(wit);  // Create work item.
                        witStore.beginGetLinkTypes(() => {
                            TestCaseHelper._populateWorkItem(workItem, requirement, this.name());   // Populate work item.
                            TestCaseHelper._showWorkItem(workItem, options);   // Show the work item.
                        });
                    });
                });
            });
    }

    public beginUpdate(): IPromise<WIT_Contracts.WorkItem> {
        var witClient = WIT_WebApi.getClient();
        return witClient.updateWorkItem(TestCaseHelper.getUpdatePatchDocument(this.name()), this.id);
    }

    public beginUpdateRequirementId(newRequirementId: number, oldRequirementId: number, removeExistingLink: boolean): IPromise<WIT_Contracts.WorkItem> {
        return this._beginGet().then((workItem: WIT_Contracts.WorkItem) => {
            var witClient = WIT_WebApi.getClient();

            if (removeExistingLink) {
                var indexOfLink: number = this._getIndexOfTestCaseInRequirement(workItem, oldRequirementId);

                if (indexOfLink < 0) {
                    removeExistingLink = false;
                }
            }

            return witClient.updateWorkItem(TestCaseHelper.getUpdateTestedByLinkPatchDocument(newRequirementId, indexOfLink, removeExistingLink), this.id);
        });
    }

    /**
     *  Remove the requirement link from test case 
     * @param requirementId
     */
    public beginRemove(requirementId: number): IPromise<WIT_Contracts.WorkItem> {
        return this._beginGet().then((workItem: WIT_Contracts.WorkItem) => {

            var indexOfLink: number = this._getIndexOfTestCaseInRequirement(workItem, requirementId);
            if (indexOfLink >= 0) {
                var witClient = WIT_WebApi.getClient();
                return witClient.updateWorkItem(TestCaseHelper.getRemoveTestCasePatchDocument(indexOfLink), this.id);
            } else {
                return Q(undefined);
            }
        });
    }

    private _getIndexOfTestCaseInRequirement(workItem: WIT_Contracts.WorkItem, requirementId: number): number {
        var indexOfLink: number = -1;
        let collectionUrl: string = TestCaseHelper.getCollectionUrl();
        if (workItem && workItem.relations) {
            $.each(workItem.relations, (index: number, relation: any) => {
                if (TestCaseHelper.compareRelationUrlWithWorkItemUrl(collectionUrl, requirementId, relation.url)) {
                    indexOfLink = index;
                    return false;
                }
            });
        }
        return indexOfLink;
    }

    private _beginGet(): IPromise<WIT_Contracts.WorkItem> {
        var witClient = WIT_WebApi.getClient();

        return witClient.getWorkItem(this.id, null, null, WIT_Contracts.WorkItemExpand.Relations);
    }
}

export class TestCaseHelper {

    public static _populateWorkItem(workItem: WITOM.WorkItem, requirement: IRequirementModel, name: string) {
        let workItemLink = WITOM.WorkItemLink.create(workItem, parentTestedByLinkName, requirement.id, Utils_String.empty);
        workItem.addLink(workItemLink);
        workItem.setFieldValue(WITConstants.CoreField.Title, name);
        workItem.setFieldValue(WITConstants.CoreField.AreaPath, requirement.areaPath);
        workItem.setFieldValue(WITConstants.CoreField.IterationPath, requirement.iterationPath);
    }

    public static _showWorkItem(workItem: WITOM.WorkItem, options?: IWorkItemOption) {
        // Show work item.
        VSS.using(["WorkItemTracking/Scripts/TFS.WorkItemTracking.Controls"], (WITControls: typeof WITControls_LAZY_LOAD) => {
            // Show the work item.
            WITControls.WorkItemFormDialog.showWorkItem(workItem, options);
        });
    }

    public static getCreatePatchDocument(name: string, requirement: IRequirementModel): VSS_Common_Contracts.JsonPatchDocument {
        var postData: VSS_Common_Contracts.JsonPatchDocument[] = [
            {
                "op": "add",
                "path": "/fields/System.Title",
                "value": name
            },
            {
                "op": "add",
                "path": "/fields/System.IterationPath",
                "value": requirement.iterationPath
            },
            {
                "op": "add",
                "path": "/relations/-",
                "value": {
                    "rel": parentTestedByLinkName,
                    "url": TestCaseHelper.getWorkItemApiUrl(requirement.id),
                    "attributes": {
                        "comment": ""
                    }
                }
            }
        ];

        if (requirement.areaPath) {
            postData.push({
                "op": "add",
                "path": "/fields/System.AreaPath",
                "value": requirement.areaPath
            });
        }
        return postData as VSS_Common_Contracts.JsonPatchDocument;
    }

    public static getUpdatePatchDocument(name: string): VSS_Common_Contracts.JsonPatchDocument {
        var postData: VSS_Common_Contracts.JsonPatchDocument = [
            {
                "op": "replace",
                "path": "/fields/System.Title",
                "value": name
            }
        ];

        return postData;
    }

    public static getUpdateTestedByLinkPatchDocument(requirementId: number, index: number, removeExistingLink: boolean) {
        var postData = [];
        if (removeExistingLink) {
            postData.push({
                "op": "remove",
                "path": "/relations/" + index,

            });
        }

        postData.push({
            "op": "add",
            "path": "/relations/-",
            "value": {
                "rel": parentTestedByLinkName,
                "url": TestCaseHelper.getWorkItemApiUrl(requirementId),
                "attributes": {
                    "comment": ""
                }
            }
        });

        return postData;
    }

    public static getRemoveTestCasePatchDocument(index: number) {
        var postData = [];
        postData.push({
            "op": "remove",
            "path": "/relations/" + index,
        });
        return postData;
    }

    public static getWorkItemApiUrl(workItemId: number): string {
        var collectionUrl = TestCaseHelper.getCollectionUrl();
        // build url
        var wiUrl = collectionUrl
            + "_apis/wit/workItems/"
            + workItemId;
        wiUrl = encodeURI(wiUrl);

        return wiUrl;
    }

    public static getCollectionUrl(): string {
        let tfsContext = TFS_Host_TfsContext.TfsContext.getDefault();
        let webContext = tfsContext.contextData;
        return webContext.collection.uri;
    }
    public static compareRelationUrlWithWorkItemUrl(collectionUrl: string, workItemId: number, relationUrl: string): boolean {
        let endsWithString = "_apis/wit/workItems/" + workItemId;
        relationUrl = relationUrl ? relationUrl : "";
        return Utils_String.startsWith(relationUrl, collectionUrl, Utils_String.ignoreCaseComparer)
            && Utils_String.endsWith(relationUrl, endsWithString, Utils_String.ignoreCaseComparer);
    }
}

export interface ITestStore {
    getSuite: (requirementId: number) => ITestSuiteModel;
    setSuite: (requirementId: number, suite: ITestSuiteModel) => void;
    refreshSuite: (requirementId: number) => IPromise<any>;
    removeSuite: (requirementId: number) => void;
    beginFetchSuites: (requirementIds: number[]) => IPromise<number[]>;
    dispose: () => void;
}

export class TestStore implements ITestStore {
    private _suiteCache: { [requirementId: number]: ITestSuiteModel } = {};
    private _teamId: string;

    constructor(teamId: string) {
        this._teamId = teamId;
    }

    /**
    * Refresh the suite corresponding to requirement
    *
    * @param requirementId requirementId of requirement
    * @return refeshed testSuiteModel
    */
    public refreshSuite(requirementId: number): IPromise<any> {
        if (requirementId <= 0) {
            return Q(undefined);
        }

        var suite = this.getSuite(requirementId);

        if (suite) {
            return suite.refresh(this._teamId, requirementId);
        }
        else {
            var suiteModel: TestSuiteModel = new TestSuiteModel();
            return suiteModel.refresh(this._teamId, requirementId).then(() => {
                this.setSuite(requirementId, suiteModel);
            });
        }
    }

    public beginFetchSuites(requirementIds: number[]): IPromise<number[]> {

        if (!requirementIds || requirementIds.length === 0) {
            return Q([]);
        }

        $.each(requirementIds, (i, requirementId) => {
            this.removeSuite(requirementId);
        });

        return WebApi.getClient().beginGetSuites(this._teamId, requirementIds)
            .then((suites: Contracts.ITestSuite[]) => {

                var requirements: number[] = [];

                // convert to model and store in cache
                $.each(suites, (i, suite: Contracts.ITestSuite) => {
                    var suiteModel = new TestSuiteModel(suite);
                    if (this._suiteCache != null) {  // to avoid client side warning message if suiteCache is null
                        this._suiteCache[suite.requirementId] = suiteModel;
                    }
                    requirements.push(suite.requirementId);
                });

                return requirements;

            });
    }

    public getSuite(requirementId: number): ITestSuiteModel {
        if (this._suiteCache != null) {
            return this._suiteCache[requirementId];
        }
        return undefined;
    }

    public setSuite(requirementId: number, suite: ITestSuiteModel): void {
        this._suiteCache[requirementId] = suite;
    }

    public removeSuite(requirementId: number): void {
        if (this._suiteCache != null) {
            this._suiteCache[requirementId] = null;
        }
    }

    public dispose() {
        this._suiteCache = null;
    }

}
